module.exports = __webpack_public_path__ + "img/404.341a2d0.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/404.png
// module id = vWx6
// module chunks = 1 2 3 4 5